// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy, mockSpecifiedItems } from './shared';

export const label = 'Contents - Has Claims';

export const policy: Policy = createMockPolicy({
  policyNumber: 'C12/43564344',
  policyDetailsId: '1218623341',
  forename: 'Albert',
  coverType: 'Contents',
  accidentalDamageLevel: { Buildings: 'Full', Contents: 'None' },
  specifiedItems: mockSpecifiedItems,
  personalPossessionsSumInsured: 550,
  claims: [
    {
      claimDate: '2021-10-25T00:00:00Z' as any,
      claimTypeDescription: 'Escape of water - other cause',
      claimNumber: '123123123123',
      claimAmount: 821.11,
      claimSection: 'Buildings Only',
      claimOutstanding: false,
      claimAtProperty: true
    }
  ]
});
